import { warnIfDevBuild } from 'utils/environment';
import React from 'react';
import ReactDOM from 'react-dom';
import App, { BasicApp } from './app';
import { logger } from 'packages';

export default initData => {
    warnIfDevBuild('discover');
    const { isHybridAppContext, isBasicApp } = initData;
    const el = document.getElementsByClassName('site-container')[0];
    if (el) {
        try {
            // Render basic app for web views, regular app otherwise
            const AppToMount =
                isHybridAppContext || isBasicApp ? BasicApp : App;
            ReactDOM.render(
                React.createElement(AppToMount, {
                    initData
                }),
                el,
                () => {
                    el.setAttribute('data-spa-mounted', true);
                }
            );
        } catch (e) {
            logger(e);
        }
    }
};
